import maskRecipientFromFindControl from 'owa-readwrite-recipient-well/lib/actions/maskRecipientFromFindControl';
import CommonFloatPickerItem from 'owa-readwrite-common-well/lib/components/CommonFloatingPickerItem';
import FindControlViewState from 'owa-recipient-common/lib/store/schema/FindControlViewState';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import * as React from 'react';
import { PersonaSize } from 'office-ui-fabric-react/lib/Persona';
import { PersonaInitialsColor } from 'office-ui-fabric-react/lib/Persona';
import { ITheme } from '@uifabric/styling';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';

let styles = require('./FindResultRecipient.scss');
let classNames = require('classnames');

export interface FindResultRecipientProps {
    viewState: FindControlViewState;
    persona: FindRecipientPersonaType;
    itemProps: any;
    onMaskRecipient: (viewState: FindControlViewState) => void;
    theme?: ITheme;
}

const FindResultRecipient = (props: FindResultRecipientProps) => {
    let { itemProps, viewState, persona, onMaskRecipient, theme } = props;

    let isImplicitGroupPersona =
        persona.PersonaTypeString &&
        persona.PersonaTypeString == 'ImplicitGroup' &&
        persona.Members &&
        persona.Members.length > 0;

    return (
        <div className={styles.selectedPeopleList}>
            <CommonFloatPickerItem
                key={persona.EmailAddress.EmailAddress}
                pickerItemData={persona}
                isHighlighted={itemProps.suggestionModel.selected}
                personaControl={getRecipientPersonaControl(persona, isImplicitGroupPersona)}
                firstLineElement={getFindRecipientFirstLine(persona)}
                secondLineElement={getFindRecipientSecondLine(persona, isImplicitGroupPersona)}
                addPickerItemAction={() => {
                    /* no-op*/
                }}
                maskPickerItemAction={maskRecipientAction(viewState, onMaskRecipient)}
                theme={theme}
            />
        </div>
    );
};

function getFindRecipientFirstLine(persona: FindRecipientPersonaType): JSX.Element {
    const emailObj = persona.EmailAddress;
    return (
        <span className={classNames(styles.personaLineOne, styles.personaTextLine)}>
            <span className={styles.personaLineOneText}>{emailObj.Name}</span>
            {emailObj.MailboxType == 'LinkedIn' && (
                <Icon className={styles.linkedInIcon} iconName={ControlIcons.LinkedInLogo} />
            )}
        </span>
    );
}

function getFindRecipientSecondLine(
    persona: FindRecipientPersonaType,
    isImplicitGroupPersona: boolean
): JSX.Element {
    if (!isImplicitGroupPersona) {
        return (
            <span className={classNames(styles.personaLineTwo, styles.personaTextLine)}>
                {persona.EmailAddress.EmailAddress}
            </span>
        );
    }

    let memberPersonas = persona.Members.map(member => {
        return (
            <div className={styles.memberPersonaImage} key={member.EmailAddress}>
                <PersonaControl
                    key={member.EmailAddress}
                    name={member.Name}
                    emailAddress={member.EmailAddress}
                    size={PersonaSize.size16}
                    showPersonaDetails={false}
                />
            </div>
        );
    });

    return <div>{memberPersonas}</div>;
}

function getRecipientPersonaControl(
    persona: FindRecipientPersonaType,
    isImplicitGroupPersona: boolean
): JSX.Element {
    let implicitGroupName = 'Implicit Group';
    let recipientEmail = persona.EmailAddress.EmailAddress;
    let recipientName = persona.EmailAddress.Name;

    if (isImplicitGroupPersona) {
        return (
            <PersonaControl
                name={implicitGroupName}
                emailAddress={recipientEmail}
                size={PersonaSize.size32}
                showPersonaDetails={false}
                initialsColor={PersonaInitialsColor.lightBlue}
            />
        );
    }

    return (
        <PersonaControl
            name={recipientName}
            emailAddress={recipientEmail}
            size={PersonaSize.size32}
            showPersonaDetails={false}
        />
    );
}

function maskRecipientAction(
    viewState: FindControlViewState,
    onMaskRecipient: (viewState: FindControlViewState) => void
): (recipientToMask: FindRecipientPersonaType) => void {
    return function(recipientToMask: FindRecipientPersonaType): void {
        logUsage('RWFindPeopleMasking');

        maskRecipientFromFindControl(viewState, recipientToMask);
        onMaskRecipient(viewState);
    };
}

export default FindResultRecipient;
